module.exports = __webpack_public_path__ + "img/phoneQRcode.7e1e7ee6.png";